<div class="container d-flex justify-content-end">
  <button id="openCreatNewUserModalBtn" mat-icon-button (click)="create()" class="mr-4">
    <i class="fa fa-2x fa-user-plus" aria-hidden="true"></i>
  </button>
</div>
<div class="container mt-5">
  <div class="mat-elevation-z8 mb-4">

    <table mat-table matSort [dataSource]="dataSource" class="w-100">

      <ng-container matColumnDef="id">
        <th mat-header-cell *matHeaderCellDef class="text-center" mat-sort-header> Id</th>
        <td mat-cell *matCellDef="let element"> {{element.id}} </td>
      </ng-container>

      <ng-container matColumnDef="username">
        <th mat-header-cell *matHeaderCellDef class="text-center" mat-sort-header> Username</th>
        <td mat-cell *matCellDef="let element"> {{element.username}} </td>
      </ng-container>


      <ng-container matColumnDef="email">
        <th mat-header-cell *matHeaderCellDef class="text-center" mat-sort-header> Email</th>
        <td mat-cell *matCellDef="let element">
          {{element.email}}
        </td>
      </ng-container>


      <ng-container matColumnDef="role">
        <th mat-header-cell *matHeaderCellDef class="text-center" mat-sort-header> Role</th>
        <td mat-cell *matCellDef="let element"> {{element.role | titlecase}} </td>
      </ng-container>

      <ng-container matColumnDef="abosId">
        <th mat-header-cell *matHeaderCellDef class="text-center" mat-sort-header> Abos id</th>
        <td mat-cell *matCellDef="let element">
            <span (keyup.enter)="modifyUser(element)" class="d-flex justify-content-center align-items-center">
              <input type="number" placeholder="Abos id" [(ngModel)]="element.abosId" class="form-control" autocomplete="off"
                     style="max-width: 150px"/>
            </span>
        </td>
      </ng-container>

      <ng-container matColumnDef="changePassword">
        <th mat-header-cell width="85px" *matHeaderCellDef class="text-center" mat-sort-header>Change password</th>
        <td mat-cell *matCellDef="let element">

          <button id="{{'openChangePasswordModal_' + element.username}}" mat-mini-fab color="primary" class="greyButton" (click)="changePassword(element.username)">
            <mat-icon><i class="fa fa-lg fa-edit" aria-hidden="true"></i></mat-icon>
          </button>


        </td>
      </ng-container>

      <ng-container matColumnDef="changeEmail">
        <th mat-header-cell width="85px" *matHeaderCellDef class="text-center" mat-sort-header>Change email</th>
        <td mat-cell *matCellDef="let element">

          <button mat-mini-fab class="greyButton" color="primary" (click)="changeEmail(element)">
            <mat-icon><i class="fa fa-lg fa-edit" aria-hidden="true"></i></mat-icon>
          </button>


        </td>
      </ng-container>

      <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
      <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
    </table>

    <mat-paginator [showFirstLastButtons]="true"
                   [pageSize]="10"
                   [pageSizeOptions]="[5, 10, 25, 100]">
    </mat-paginator>
  </div>
</div>
